import SvgIcon from "@mui/material/SvgIcon";

const British = function () {
  return (
    <SvgIcon viewBox="0 0 22 18">
      <rect width="22.4" height="16" rx="2" fill="white" />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="23"
        height="16"
      >
        <rect width="22.4" height="16" rx="2" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <rect width="22.4" height="16" fill="#0A17A7" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.33892 10.6667L-2.21899 15.7646L-1.02605 17.5332L8.53326 11.0853V17.0667H13.8666V11.0853L23.4259 17.5332L24.6189 15.7646L17.0609 10.6667H22.3999V5.33335H17.0609L24.6189 0.23547L23.4259 -1.53314L13.8666 4.9147V-1.06665H8.53326V4.91469L-1.02604 -1.53314L-2.21899 0.235472L5.33892 5.33335H-7.53403e-05V10.6667H5.33892Z"
          fill="white"
        />
        <path
          d="M14.9343 5.06575L25.0666 -1.60001"
          stroke="#DB1F35"
          strokeWidth="0.666667"
          strokeLinecap="round"
        />
        <path
          d="M16.0103 10.958L25.0933 17.0803"
          stroke="#DB1F35"
          strokeWidth="0.666667"
          strokeLinecap="round"
        />
        <path
          d="M6.40435 5.04836L-3.07007 -1.33679"
          stroke="#DB1F35"
          strokeWidth="0.666667"
          strokeLinecap="round"
        />
        <path
          d="M7.43195 10.8839L-3.07007 17.8484"
          stroke="#DB1F35"
          strokeWidth="0.666667"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 9.6H9.6V16H12.8V9.6H22.4V6.4H12.8V0H9.6V6.4H0V9.6Z"
          fill="#E6273E"
        />
      </g>
    </SvgIcon>
  );
};
export default British;
